import { h, JSX } from 'preact'

import { Select, SelectProps } from '../../components/forms/select/select'
import { Textfield, TextfieldProps } from '../../components/forms/textfield/textfield'

export interface ProductFiltersSectionProps {
    categories: SelectProps
    search: TextfieldProps
}

export const ProductFiltersSection = (props: ProductFiltersSectionProps): JSX.Element => (
    <div class="checkout__section">
        <div class="checkout__section-content">
            <div class="checkout__filters">
                <div class="checkout__categories">
                    <Select modifier="select--hide-label" {...props.categories} />
                </div>
                <div class="checkout__search">
                    <Textfield modifier="form-textfield--hidden-label" {...props.search} />
                </div>
            </div>
        </div>
    </div>
)
